<template>
  <div>
    <el-scrollbar>
      <el-menu mode="vertical"
               :show-timeout="200"
               :default-active="defaultActive"
               :collapse="false"
               :router="true"
               :unique-opened="true"
               background-color="#323944"
               text-color="#bfcbd9">
        <el-submenu v-for="e in list"
                    :key="e.id"
                    :index="e.id"
                    :route="e.index">
          <template slot="title">
            <i :class="e.img"
               style="color:rgb(191, 203, 217)"></i>
            <span>{{ e.title }}</span>
          </template>
          <el-menu-item v-for="child in e.child"
                        :key="child.id"
                        :index="child.id"
                        :route="child.index">{{ child.title }}</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultActive: "",
      list: []
    };
  },
  mounted() {
    this.list = [];
    if (localStorage.getItem("isAdmin") == "true") {
      this.list = [
        {
          component: "",
          title: "管理员模块",
          icon: "001",
          id: "administrators",
          img: "el-icon-s-grid",
          child: [
            {
              component: "",
              index: "/administrators/administrators/list",
              title: "企业列表",
              id: "administratorslist"
            }
            // ,
            // {
            //   component: "",
            //   index: "/home/administrators/log",
            //   title: "企业操作日志",
            //   id: "administratorslog"
            // }
          ]
        }
      ];
    } else {
      this.list = [
        {
          component: "",
          title: "员工模块",
          id: "personnel",
          img: "el-icon-user-solid",
          child: [
            {
              component: "",
              index: "/home/enterprise/personnel/employeeList",
              title: "员工列表",
              id: "employeeList"
            }
          ]
        },
        {
          component: "",
          title: "部门模块",
          id: "department",
          img: "el-icon-office-building",
          child: [
            {
              component: "",
              index: "/home/enterprise/department/list",
              title: "部门列表",
              id: "departmentList"
            }
          ]
        },
        {
          component: "",
          title: "批次模块",
          id: "batch",
          img: "el-icon-s-unfold",
          child: [
            {
              component: "",
              index: "/home/enterprise/batch/batchList",
              title: "批次列表",
              id: "batchList"
            },
            {
              component: "",
              index: "/home/enterprise/batch/batchListProgress",
              title: "批次进度",
              id: "batchListProgress"
            }
          ]
        },
        {
          component: "",
          title: "工作模块",
          id: "employeeWorkloadList",
          img: "el-icon-s-marketing",
          child: [
            {
              component: "",
              index:
                "/home/enterprise/employeeWorkload/employeeWorkloadAllList",
              title: "工作集合",
              id: "employeeWorkloadAllList"
            }
          ]
        },
        {
          component: "",
          title: "工资模块",
          id: "pay",
          img: "el-icon-money",
          child: [
            {
              component: "",
              index: "/home/enterprise/pay/employeeSalary",
              title: "员工月工资",
              id: "employeeSalary"
            },
            {
              component: "",
              index: "/home/enterprise/pay/punchStatistics",
              title: "打卡记录",
              id: "punchStatistics"
            }
          ]
        }
        // ,
        // {
        //   component: "",
        //   title: "日志模块",
        //   id: "log",
        //   img: "el-icon-message-solid",
        //   child: [
        //     {
        //       component: "",
        //       index: "/home/enterprise/log/batchOperation",
        //       title: "批次操作记录",
        //       id: "batchOperation"
        //     },
        //     {
        //       component: "",
        //       index: "/home/enterprise/log/workloadOperation",
        //       title: "工作量操作记录",
        //       id: "workloadOperation"
        //     },
        //     {
        //       component: "",
        //       index: "/home/enterprise/log/employeeInformation",
        //       title: "员工信息操记录",
        //       id: "employeeInformation"
        //     },
        //     {
        //       component: "",
        //       index: "/home/enterprise/log/businessOperations",
        //       title: "企业信息操记录",
        //       id: "businessOperations"
        //     }
        //   ]
        // }
      ];
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      var path = this.$route.path.split("/")[4];
      if (localStorage.getItem("isAdmin") == "true") {
        path = "administratorslist";
      }
      this.defaultActive = path;
    }
  }
};
</script>
<style lang="scss" scoped></style>
